// Builds Update Existing rows and decides which fields may be compared.
// A column that is unmapped or absent is never proposed as a change, and an
// empty cell never blanks a field the transaction must always have.

export const REQUIRED_FIELDS = ['transaction_date', 'description', 'amount', 'transaction_type', 'category_id'];

const COLUMN_FIELDS = {
  date: 'transaction_date',
  description: 'description',
  category: 'category_name',
  categoryId: 'category_id',
  amount: 'amount',
  type: 'transaction_type',
  direction: 'direction',
  reference: 'reference_number',
};

export function isMapped(colIndex) {
  return colIndex !== '' && colIndex !== null && colIndex !== undefined;
}

export function isBlank(value) {
  return value === null || value === undefined || String(value).trim() === '';
}

// cells: the row's raw values; mapping: field -> column index.
// Returns null when the row has no ID. Only mapped columns become keys.
export function buildUpdateRow(cells, mapping, normalizeType = (v) => v) {
  const cell = (colIndex) => {
    const value = cells[parseInt(colIndex, 10)];
    const text = value === null || value === undefined ? '' : String(value).trim();
    return text === '' ? null : text;
  };
  if (!isMapped(mapping.id)) return null;
  const id = cell(mapping.id);
  if (!id) return null;
  const row = { id: parseInt(id, 10) };
  Object.entries(COLUMN_FIELDS).forEach(([column, field]) => {
    if (!isMapped(mapping[column])) return;
    let value = cell(mapping[column]);
    if (field === 'transaction_type') value = normalizeType(value);
    if (field === 'amount') value = value === null ? null : parseFloat(String(value).replace(/[$,]/g, ''));
    if (field === 'amount' && Number.isNaN(value)) value = null;
    if (field === 'category_id' && value !== null) value = parseInt(value, 10);
    row[field] = value;
  });
  return row;
}

// True when the file supplies a usable value for this field.
export function shouldCompare(updated, key) {
  if (key === 'category_id') {
    return !isBlank(updated.category_id) || !isBlank(updated.category_name);
  }
  if (!Object.prototype.hasOwnProperty.call(updated, key)) return false;
  if (REQUIRED_FIELDS.includes(key) && isBlank(updated[key])) return false;
  return true;
}

// Removes keys the server must never receive as blanks.
export function cleanPayloadRow(row) {
  const out = {};
  Object.entries(row).forEach(([key, value]) => {
    if (value === undefined) return;
    if (REQUIRED_FIELDS.includes(key) && isBlank(value)) return;
    out[key] = value;
  });
  return out;
}